import React from 'react';
import { Navbar, Footer, AnnouncementBar } from "../components";

const Delivery = () => {
  return (
    <>
      <AnnouncementBar />
      <Navbar />
      <div className="container my-4">
        <h2 className="mb-3">Delivery & Shipping</h2>
        <p className="text-muted">Learn how delivery works at PrimeBrothers.</p>
        <hr />
        <div className="row g-4">
          <div className="col-md-6">
            <div className="p-3 border rounded-3 h-100">
              <h5>Standard Delivery</h5>
              <ul className="mb-0">
                <li>3-5 business days in major cities</li>
                <li>5-7 business days in other areas</li>
                <li>Free on orders over Rs 2,000</li>
              </ul>
            </div>
          </div>
          <div className="col-md-6">
            <div className="p-3 border rounded-3 h-100">
              <h5>Express Delivery</h5>
              <ul className="mb-0">
                <li>1-2 business days in major cities</li>
                <li>Extra charges apply at checkout</li>
                <li>Real-time tracking included</li>
              </ul>
            </div>
          </div>
          <div className="col-md-6">
            <div className="p-3 border rounded-3 h-100">
              <h5>Cash on Delivery (COD)</h5>
              <ul className="mb-0">
                <li>Available for most locations</li>
                <li>Please have the exact amount ready</li>
              </ul>
            </div>
          </div>
          <div className="col-md-6">
            <div className="p-3 border rounded-3 h-100">
              <h5>Returns & Exchanges</h5>
              <ul className="mb-0">
                <li>7-day easy returns policy</li>
                <li>Items must be unused and in original packaging</li>
              </ul>
            </div>
          </div>
        </div>
        <div className="alert alert-info mt-4" role="alert">
          Questions? Contact us at <a href="#/contact">Contact</a> and we’ll be happy to help.
        </div>
      </div>
      <Footer />
    </>
  );
};

export default Delivery;
